export const LoginLogo = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
    >
        <rect x="0.132324" width="30" height="30" rx="15" fill="#EEEEEE" />
        <g clipPath="url(#clip0_13254_8523)">
            <path
                d="M17.9135 16.5C17.0073 16.5 16.6011 17 15.1323 17C13.6323 17 13.2261 16.5 12.3198 16.5C10.0073 16.5 8.13232 18.4062 8.13232 20.7188V21.5C8.13232 22.3438 8.78857 23 9.63232 23H20.6323C21.4448 23 22.1323 22.3438 22.1323 21.5V20.7188C22.1323 18.4062 20.2261 16.5 17.9135 16.5ZM20.6323 21.5H9.63232V20.7188C9.63232 19.2188 10.8198 18 12.3198 18C12.7886 18 13.5073 18.5 15.1323 18.5C16.7261 18.5 17.4448 18 17.9135 18C19.4135 18 20.6323 19.2188 20.6323 20.7188V21.5ZM15.1323 16C17.6011 16 19.6323 14 19.6323 11.5C19.6323 9.03125 17.6011 7 15.1323 7C12.6323 7 10.6323 9.03125 10.6323 11.5C10.6323 14 12.6323 16 15.1323 16ZM15.1323 8.5C16.7573 8.5 18.1323 9.875 18.1323 11.5C18.1323 13.1562 16.7573 14.5 15.1323 14.5C13.4761 14.5 12.1323 13.1562 12.1323 11.5C12.1323 9.875 13.4761 8.5 15.1323 8.5Z"
                fill="#292929"
            />
        </g>
        <defs>
            <clipPath id="clip0_13254_8523">
                <rect
                    width="30"
                    height="30"
                    fill="white"
                    transform="translate(0.132324)"
                />
            </clipPath>
        </defs>
    </svg>
)
